import { Popper, styled } from '@mui/material';
import theme from 'theme';

const PREFIX = 'FloatingButtonOptions';

export const classes = {
  paper: `${PREFIX}-paper`,
  menuList: `${PREFIX}-menuList`,
};

export const StyledPopper = styled(Popper)(() => ({
  [`& .${classes.paper}`]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },

  [`& .${classes.menuList}`]: {
    '& .MuiListItem-root': {
      textAlign: 'right',
      justifyContent: 'end',
      width: 'fit-content',
    },
    '& .MuiMenuItem-root': {
      marginLeft: 'auto',
      backgroundColor: '#037DE8',
      color: '#FFFFFF',
      margin: '0.8rem 0',
      borderRadius: theme.spacing(0.5),
      textTransform: 'uppercase',
    },
    '& .MuiListItem-button:hover': {
      backgroundColor: '#043A6E',
    },
  },
}));
